import styled from "styled-components";
import { comum } from "../../../../styles/Themes/light";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 24px;
    text-align: center;
    width: 100%;

    @media (max-width: 768px) {
        padding: 40px 16px;
    }
`;

export const IconContainer = styled.div`
    margin-bottom: 20px;
    color: ${({ theme }) => theme.colors.interfaceDanger400 || comum.colors.interfaceDanger400 || '#EF4444'};
    opacity: 0.8;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Mensagem = styled.p`
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.interfaceText400 || '#6B7280'};
    line-height: 1.5;
    margin: 0;
    max-width: 400px;
`;


